export default {
  EXPEDITED_SHIPPING_RESTRICTION: 'expeditedShippingRestriction',
  INTERNATIONAL_SHIPPING_RESTRICTION: 'internationalShippingRestriction',
  STORE_PICKUP_RESTRICTION: 'storePickupRestriction',
}
